module.exports = __webpack_public_path__ + "img/area-limit-bg.adf50f67.png";